import { FormDataService } from './form.data.service';
import { BaseDataModel } from '../../models/utilitymodels/base.model';
import { BaseWidgetService } from './base.widget.service';
import { Injectable } from '@angular/core';
import { SystemService } from './system.service';
import { API_URL } from 'common/constants/url.constants';

@Injectable({
    providedIn: 'root',
})
export abstract class FormDataWidgetService<T extends BaseDataModel> extends BaseWidgetService<T> {
    constructor(public service: FormDataService<T>, public systemService: SystemService) {
        super(service, systemService);
    }

    processFormModel(model: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            this.service
                .postData(model)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    processFormModelGETAPI(params: string[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.service
                .getData(params)
                .then((data: any) => {
                    resolve(data);
                })
                .catch((err: any) => {
                    reject(err);
                });
        });
    }

    onSucccessLoginApi(url: string = API_URL.dashboardLoginSucccess): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.service
                .getDataByUrl(url)
                .then((data: any) => {
                    resolve(data);
                })
                .catch((err: any) => {
                    reject(err);
                });
        });
    }


}
